
//login and signup
import { forgotPassword, login, otpVerify, refreshToken, resetPassword, signupPro, signupClient } from "./action/loginAndSignUp"
import { getFooterPost } from './action/footerdetailapi'
import { getAllTeam } from './action/ourTeamapi'
import { getJobAllDetail, changeJobFilters } from './action/jobgetapi'
import { getAllFaq } from "./action/faqsApi"

export const actionsApi = {
    login, 
    signupPro,
    signupClient,
    refreshToken,
    forgotPassword,
    resetPassword,
    otpVerify,
    // footer detail api
    getFooterPost,
    // our team
    getAllTeam,
    // job api
    getJobAllDetail, changeJobFilters,
    // faqs
    getAllFaq
}
